import { Counter, TABLE_VARIANT } from '../../Counter'
import { DashboardListRow } from '../DashboardListRow'

import EmailIcon from '../../../icons/email.svg'

function BirdviewMailboxRow({ item, onOpen }) {
  function handleOpen() {
    onOpen(item)
  }

  return (
    <DashboardListRow
      isUnread
      Icon={EmailIcon}
      Meta={Counter}
      metaProps={{ count: item.unread, variant: TABLE_VARIANT }}
      title={item.title}
      onAction={handleOpen}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewMailboxRow
